import {
  ADD_TOAST,
  REMOVE_TOAST,
  HIDE_TOAST,
} from "../../actions/generic/types";
import _ from "lodash";

const INITIAL_STATE = [
  //   {
  //     id: 0,
  //     type: 0,
  //     text: "Info: Toast number 1",
  //   },
  //   {
  //     id: 1,
  //     type: 1,
  //     text: "Success: Toast number 2",
  //     isShowing: true,
  //     delay: 5000,
  //   },
  //   {
  //     id: 2,
  //     type: 2,
  //     text: "Failure: Toast number 3",
  //   },
  //   {
  //     id: 3,
  //     type: 3,
  //     text: "Warning: Toast number 4",
  //   },
];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_TOAST: {
      let newToastList = _.cloneDeep(state);
      newToastList.push(action.toastInfo);
      return newToastList;
    }
    case HIDE_TOAST: {
      let newToastList = _.cloneDeep(state);
      newToastList.forEach((toastInfo) => {
        if (toastInfo.id === action.id) toastInfo.isShowing = false;
      });
      return newToastList;
    }
    case REMOVE_TOAST: {
      let newToastList = _.cloneDeep(state);
      newToastList = newToastList.filter(
        (toastInfo) => toastInfo.id != action.id
      );
      return newToastList;
    }
    default:
      return state;
  }
};
